import { el } from "../utils/dom.ts";
import { Panel } from "./panel-base.ts";
import { getIndicatorsWeekly, type WeeklyIndicator } from "../services/api-client.ts";
import { domainPulse, type DomainPulse } from "../utils/metrics.ts";
import { DOMAIN_LABELS, type Domain } from "../../functions/_shared/event-taxonomy.ts";
import { signalSourceLabel } from "./signal-source-label.ts";

// Domain Pulse — a compact metric strip: one card per domain showing this-week's
// event count vs the prior available week (WoW arrow). Data is sparse, so cards
// degrade to an "accumulating" state rather than faking a trend.
export class DomainPulsePanel extends Panel {
  constructor() {
    super({ id: "domain-pulse", title: "Nhịp hoạt động theo lĩnh vực", subtitle: "tuần này vs tuần trước" });
    this.setContent(el("div", { className: "panel-loading" }, ["Đang tải…"]));
  }

  async load(): Promise<void> {
    try {
      const { items } = await getIndicatorsWeekly("?scope=national&weeks=12");
      this.render(items);
    } catch {
      this.setError();
    }
  }

  private render(weekly: WeeklyIndicator[]): void {
    const pulse = domainPulse(weekly);
    const grid = el("div", { className: "pulse-grid" });
    for (const p of pulse) grid.append(this.card(p));
    this.setContent(grid, el("div", { className: "pulse-source" }, [signalSourceLabel("media")]));
  }

  private card(p: DomainPulse): HTMLElement {
    const label = DOMAIN_LABELS[p.domain as Domain] ?? p.domain;
    const hasData = p.latestWeek !== null;
    const arrow = p.direction === "up" ? "▲" : p.direction === "down" ? "▼" : "▪";
    const deltaStr =
      p.deltaPct === null
        ? ""
        : `${p.deltaPct >= 0 ? "+" : ""}${Math.round(p.deltaPct) === 0 ? 0 : p.deltaPct.toFixed(0)}%`;
    return el("div", { className: `pulse-card pulse-${p.direction}` }, [
      el("span", { className: "pulse-domain" }, [label]),
      el("span", { className: "pulse-count" }, [hasData ? String(p.latest) : "—"]),
      hasData
        ? el("span", { className: "pulse-delta" }, [
            el("span", { className: "pulse-arrow" }, [arrow]),
            el("span", {}, [deltaStr || "mới"]),
          ])
        : el("span", { className: "pulse-empty" }, ["đang tích lũy"]),
    ]);
  }
}
